import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, Divider, Container } from '@mui/material';

export const ContentBox = styled(Box)(
  ({ padding = '15px 20px', backgroundColor = '#fff', rowGap = '10px' }) => ({
    position: 'relative',
    padding,
    backgroundColor,
    rowGap,
    display: 'flex',
    flexDirection: 'column',
    '& .link': {
      textDecoration: 'underline',
    },
  }),
);

export const StyledDivider = styled(Divider)(() => ({
  margin: '8px 0',
}));

export const StyledToolBarButton = styled(Button)(({ theme, sx, flex }) => {
  const { main } = theme.palette.toolbar;
  return {
    lineHeight: '24px',
    paddingTop: '8px',
    paddingBottom: '8px',
    fontSize: '14px',

    '&.MuiButton-outlinedPrimary': {
      borderColor: main,
      color: 'black',
    },
    '&.MuiButton-containedPrimary': {
      border: `1px solid ${main}`,
      background: main,
    },
    flex,
    ...sx,
  };
});

const ContentContainerSx = {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '28px',
  marginBottom: '16px',
};

export function ContentContainer({ sx = {}, p = 3, children, ...props }) {
  return (
    <Container
      disableGutters={true}
      sx={{ ...ContentContainerSx, p, ...sx }}
      {...props}
    >
      {children}
    </Container>
  );
}

export const flexCenter = { display: 'flex', justifyContent: 'center' };
export const flexVertical = { flexDirection: 'column', alignItems: 'center' };
export const flexSpaceBetween = {
  display: 'flex',
  justifyContent: 'space-between',
};
export const bordered = (style = 'thin') => ({
  borderColor: 'primary.main',
  borderStyle: 'solid',
  borderWidth: style === 'thin' ? '1px' : '6px',
  backgroundColor: '#fff',
});
export const shadowed = {
  boxShadow:
    '0px 3px 10px -2px rgb(0 0 0 / 7%), -2px 2px 12px 0px rgb(0 0 0 / 2%), 0px 1px 5px 0px rgb(0 0 0 / 1%)',
};
export const floatLeft = { marginRight: 'auto', float: 'left' };
export const floatRight = { marginLeft: 'auto', float: 'right' };
export const absoluteRight = (right) => ({
  position: 'absolute',
  right,
});
export const height100 = { height: '100%' };
export const RequiredDot = styled('span')({
  color: 'red',
  position: 'relative',
  left: -4,
});

export const ScrollStyle = ({ x = false, y = false }) => {
  if (!x && !y) return { overflow: 'scroll' };
  if (x) return { overflowX: 'scroll' };
  if (y) return { overflowY: 'scroll' };
};

export const overflowHidden = {
  overflow: 'hidden',
};

export const width100 = {
  width: '100%',
};
